module.exports = __webpack_public_path__ + "img/icon4.76259c90.png";